module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-pro@4x.9c391b8c.png" + "?" + Date.now();